import axios from "axios";
import { ElMessage } from "element-plus";

class AxiosUtils {
  constructor(baseURL = "") {
    this.instance = axios.create({
      baseURL,
      timeout: 100000, // 默认超时时间
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        TENANT_ID: "1",
        Authorization: localStorage.getItem("token") || "",
      },
    });

    // 请求拦截器
    this.instance.interceptors.request.use(
      (config) => {
        // 可在此添加 token、loading 等逻辑
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );

    // 响应拦截器
    this.instance.interceptors.response.use(
      (response) => {
        if (response.data.code !== "00000" && response.data.code != "200") {
          if (response.data.code === "A00004") {
            localStorage.removeItem("token");
            ElMessage.error("账号过期，或未登录，请重新登录");
            return;
          }

          ElMessage.error(response.data.msg);
          return Promise.reject(new Error(response.data.msg || "业务错误"));
        } else {
          return response.data.data; // 直接返回 data 部分
        }
      },
      (error) => {
        // 处理网络错误或业务异常
        console.error("请求出错:", error);
        // ElMessage.error(error.message)
        ElMessage.error("网络错误，请稍后再试");
        return Promise.reject(error);
      }
    );
  }

  /**
   * 通用 GET 请求
   */
  get(url, params = {}) {
    return this.instance.get(url, {
      params,
    });
  }

  /**
   * 通用 POST 请求
   */
  post(url, data, config) {
    return this.instance.post(url, data, config);
  }

  /**
   * 通用 PUT 请求
   * @param {string} url - 请求地址
   * @param {Object} data - 发送的数据
   * @param {Object} [config] - axios 配置项
   */
  put(url, data, config) {
    return this.instance.put(url, data, config);
  }

  /**
   * 通用 DELETE 请求
   * @param {string} url - 请求地址
   * @param {Object} [config] - axios 配置项（可选）
   */
  delete(url, config) {
    return this.instance.delete(url, config);
  }

  /**
   * 文件上传方法
   * @param {string} url - 接口地址
   * @param {File} file - 要上传的文件对象
   * @param {Object} [customData] - 额外参数（可选）
   */
  uploadFile(url, file, customData) {
    const formData = new FormData();
    formData.append("file", file); // 假设后端接收字段名为 'file'

    if (customData) {
      Object.keys(customData).forEach((key) => {
        formData.append(key, customData[key]);
      });
    }

    return this.instance.post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
}

// 示例：创建一个实例
const apiClient = new AxiosUtils(
  process.env.NODE_ENV === "development" ? "/fun-api" : "/api"
);

export default apiClient;
